@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.button {
  flex: 1;
  margin: 8px 0;

  &:first-child {
    margin-bottom: 0;
  }

  &:last-child {
    margin-top: 0;
  }

  /* stylelint-disable max-nesting-depth */
  @include breakpoints.desktop {
    margin: 0 8px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
  /* stylelint-enable max-nesting-depth */
}

.message {
  text-align: center;
  margin-bottom: 32px;
  margin-top: 8px;
  font-family: typography.$font-mont;
}

.buttons {
  display: flex;
  flex-direction: column-reverse;

  @include breakpoints.desktop {
    flex-direction: row;
  }
}

.header {
  @include typography.body-semibold;
  text-align: center;
  margin-top: 0;
  margin-bottom: 28px;
}
